import { Element } from "../../element.js";
/**
 * @public
 */
export function isScopedTo(name, ...rest) {
    return (element) => element
        .ancestors()
        .filter(Element.isElement)
        .some(Element.hasName(name, ...rest));
}
//# sourceMappingURL=is-scoped-to.js.map